import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { UserState } from '../../states';

/**
 * Awaits the initial user load that runs during app initialization
 * (`provideAppInitializer` → `UserActions.LoadMe`). All `CanActivateFn`
 * route guards in the app share this prelude so that role/identity checks
 * never race the OIDC sign-in.
 */
export const waitForUserLoaded = async (store: Store): Promise<void> => {
    await firstValueFrom(
        store.select(UserState.loaded).pipe(
            filter((loaded) => loaded),
            take(1)
        )
    );
};
